/* Event landing page (sections/hx-event-page.liquid): countdown, query-string-safe anchors, the
   Add to calendar menu and calendar file, registration checks or the app form's set-up, scroll reveal
   and lead events. No new
   tracking scripts: the lead events only fire through gtag and fbq when the site already has them.
   Each event section sets itself up on load and again when the theme editor reloads it. */
(function () {
  'use strict';

  if (!document.querySelector('.hx-ev')) return;

  /* ---- Add to calendar menu: closes on Escape, on a click elsewhere and once an option is picked ---- */
  const menus = () => Array.from(document.querySelectorAll('[data-hx-ev-cal]'));
  document.addEventListener('click', (event) => {
    const inside = event.target.closest('[data-hx-ev-cal]');
    menus().forEach((menu) => { if (menu !== inside) menu.open = false; });
    if (inside && event.target.closest('.hx-ev-cal__item')) inside.open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = menus().find((menu) => menu.open);
    if (!open) return;
    open.open = false;
    open.querySelector('summary').focus();
  });

  /* ---- Calendar file (.ics), in Toronto time ---- */
  const icsText = (value) => String(value || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
  // Lines over 75 characters are folded, as the calendar format asks
  const fold = (line) => {
    const out = [];
    let rest = line;
    while (rest.length > 74) { out.push(rest.slice(0, 74)); rest = ' ' + rest.slice(74); }
    out.push(rest);
    return out.join('\r\n');
  };
  const stamp = () => new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  const downloadIcs = (btn) => {
    const d = btn.dataset;
    const lines = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Hatch Group//Event page//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
      'BEGIN:VTIMEZONE', 'TZID:America/Toronto',
      'BEGIN:DAYLIGHT', 'TZOFFSETFROM:-0500', 'TZOFFSETTO:-0400', 'TZNAME:EDT', 'DTSTART:19700308T020000', 'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU', 'END:DAYLIGHT',
      'BEGIN:STANDARD', 'TZOFFSETFROM:-0400', 'TZOFFSETTO:-0500', 'TZNAME:EST', 'DTSTART:19701101T020000', 'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU', 'END:STANDARD',
      'END:VTIMEZONE',
      'BEGIN:VEVENT',
      `UID:${d.uid}`,
      `DTSTAMP:${stamp()}`,
      `DTSTART;TZID=America/Toronto:${d.start}`,
    ];
    if (d.end) lines.push(`DTEND;TZID=America/Toronto:${d.end}`);
    lines.push(
      `SUMMARY:${icsText(d.title)}`,
      `LOCATION:${icsText(d.location)}`,
      `DESCRIPTION:${icsText(d.description)}`,
      `URL:${d.url}`,
      'END:VEVENT', 'END:VCALENDAR'
    );
    const blob = new Blob([lines.map(fold).join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = d.file || 'event.ics';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => { URL.revokeObjectURL(link.href); link.remove(); }, 1000);
  };

  /* ---- Lead events, once per registration label and browser session ---- */
  const lead = (label) => {
    let fired = false;
    try { fired = sessionStorage.getItem('hx-ev-lead') === label; } catch (e) { /* storage blocked */ }
    if (fired) return;
    try { sessionStorage.setItem('hx-ev-lead', label); } catch (e) { /* storage blocked */ }
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { event_category: 'seminar', event_label: label });
    if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: label });
  };
  const announce = (panel) => {
    panel.scrollIntoView({ block: 'center' });
    panel.focus({ preventScroll: true });
    lead(panel.dataset.label || '');
  };
  const escapeHtml = (text) => String(text).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const init = (root) => {
    /* ---- In-page links keep the page's query string (UTM tags) ---- */
    root.querySelectorAll('[data-hx-ev-anchor]').forEach((a) => {
      const hash = (a.getAttribute('href') || '').replace(/^[^#]*/, '');
      if (hash) a.setAttribute('href', window.location.pathname + window.location.search + hash);
    });

    /* ---- Countdown: shown while the start is ahead, hidden once the event has started ---- */
    root.querySelectorAll('[data-hx-ev-countdown]').forEach((box) => {
      const start = Date.parse(box.dataset.start || '');
      if (!start) return;
      const cell = (u) => box.querySelector(`[data-u="${u}"]`);
      const cells = { d: cell('d'), h: cell('h'), m: cell('m') };
      let timer = 0;
      const tick = () => {
        const left = Math.floor((start - Date.now()) / 1000);
        if (!(left > 0)) {
          box.hidden = true;
          clearInterval(timer);
          return;
        }
        box.hidden = false;
        cells.d.textContent = Math.floor(left / 86400);
        cells.h.textContent = String(Math.floor((left % 86400) / 3600)).padStart(2, '0');
        cells.m.textContent = String(Math.floor((left % 3600) / 60)).padStart(2, '0');
      };
      tick();
      timer = setInterval(tick, 15000);
    });

    root.querySelectorAll('[data-hx-ev-ics]').forEach((btn) => btn.addEventListener('click', () => downloadIcs(btn)));

    /* ---- Registration form: inline checks, then Shopify's contact form posts as usual ---- */
    root.querySelectorAll('form.hx-ev-form').forEach((form) => {
      const grid = form.querySelector('.hx-ev-form__grid');
      if (!grid) return;
      const msg = {
        required: grid.dataset.errRequired || '',
        select: grid.dataset.errSelect || grid.dataset.errRequired || '',
        email: grid.dataset.errEmail || '',
        phone: grid.dataset.errPhone || '',
      };
      const check = (wrap) => {
        const input = wrap.querySelector('input, select');
        const error = wrap.querySelector('.hx-ev-field__error');
        const value = (input.value || '').trim();
        let text = '';
        if (input.required && !value) text = input.tagName === 'SELECT' ? msg.select : msg.required;
        else if (input.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) text = msg.email;
        // North American numbers: at least 10 digits, with or without spaces, dashes, brackets or +1
        else if (input.hasAttribute('data-hx-ev-phone') && value && value.replace(/\D/g, '').length < 10) text = msg.phone;
        wrap.classList.toggle('is-invalid', !!text);
        if (text) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
        if (error) { error.textContent = text; error.hidden = !text; }
        return !text;
      };
      const wraps = Array.from(form.querySelectorAll('[data-hx-ev-field]'));
      // Once a field has shown an error, it re-checks as the visitor types
      wraps.forEach((wrap) => {
        const input = wrap.querySelector('input, select');
        ['input', 'change'].forEach((type) => input.addEventListener(type, () => { if (wrap.classList.contains('is-invalid')) check(wrap); }));
      });

      form.addEventListener('submit', (event) => {
        const bad = wraps.filter((wrap) => !check(wrap));
        if (!bad.length) return;
        event.preventDefault();
        bad[0].querySelector('input, select').focus();
      });
    });

    /* ---- Powerful Form Builder form (data-hx-ev-pfb). The app draws the form into the box after load.
       The message starts with the seminar line unless the visitor wrote their own (the app restores a
       draft of the fields on every page, so a line the site filled in earlier is replaced, as hatch.js
       does for quotes); the button gets the page's label; once the app shows its sent message, the
       page's success panel with Add to calendar takes the form's place and the lead events fire ---- */
    root.querySelectorAll('[data-hx-ev-pfb]').forEach((box) => {
      const done = box.parentElement.querySelector('[data-hx-ev-done]');
      const label = box.dataset.submit ? '<span class="spinner"></span>' + escapeHtml(box.dataset.submit) : '';
      let form = null;
      let sent = false;
      const watch = () => {
        const current = box.querySelector('form');
        if (!current) return;
        // The app can draw the form more than once, so each new form is set up again
        if (current !== form) {
          form = current;
          const area = form.querySelector('textarea');
          const line = box.dataset.prefill || '';
          if (area && line) {
            let last = '';
            try { last = window.localStorage.getItem('hxQuotePrefill') || ''; } catch (e) { /* storage blocked */ }
            if (!area.value || area.value === last) {
              area.value = line;
              try { window.localStorage.setItem('hxQuotePrefill', line); } catch (e) { /* storage blocked */ }
            }
            // The app floats a field's label above a value with this class
            const tag = area.value && form.querySelector(`label[for="${area.id}"]`);
            if (tag) tag.classList.add('gfb__label__filled');
          }
        }
        // The app writes data-submit-text back into the button after sending, spinner first
        const button = form.querySelector('button[type="submit"]');
        if (button && label && button.dataset.submitText !== label) {
          button.dataset.submitText = label;
          button.innerHTML = label;
        }
        const ok = Array.from(box.querySelectorAll('.message.success')).some((el) => el.getClientRects().length);
        if (!sent && done && ok) {
          sent = true;
          done.hidden = false;
          box.hidden = true;
          announce(done);
        }
      };
      new MutationObserver(watch).observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      watch();
    });

    /* ---- Bands rise in as they scroll into view; not in the theme editor or with reduced motion ---- */
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode);
    if (!still && 'IntersectionObserver' in window) {
      const seen = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        seen.unobserve(entry.target);
      }), { rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll('[data-hx-ev-reveal]').forEach((el) => seen.observe(el));
      root.classList.add('hx-ev--anim');
    }
  };

  document.querySelectorAll('.hx-ev').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.hx-ev').forEach(init));

  /* ---- After a successful registration through Shopify's contact form: bring the message into view ---- */
  const success = document.querySelector('[data-hx-ev-success]');
  if (success) announce(success);
})();
